import {
  takeLatest,
  take,
  fork,
  all,
  call,
  select,
  put,
} from 'redux-saga/effects'

import {
  MOUNT,
  UNMOUNT
} from './constants'

import {
  clear,
} from 'containers/Admin/Client/ClientSelection/actions'

import {
  removeTables,
} from 'containers/Entity/actions'

function* handleMount() {
  yield put(clear())
  yield put(removeTables('partner_sites'))
}

function* watchMount() {
  yield takeLatest(MOUNT, handleMount)
}

function* watchUnmount() {
  yield takeLatest(UNMOUNT, handleMount)
}

function* loadSagas() {
  yield all([
    fork(watchMount),
    fork(watchUnmount),
  ])
}

export default loadSagas
